<template>
  <Card class="card p-4 h-100">
    <div class="d-flex align-items-center h-80px border-bottom position-relative">
      <AvatarBadge v-if="isGroupConversation" class="symbol-50px" :fullname="currentConversationName" />
      <AvatarBadge v-else class="symbol-40px" :online="isOnline" :fullname="currentConversationName" :avatar-url="currentConversation?.peer?.avatar_url" />
      <div class="flex-grow-1 d-flex flex-column ms-7">
        <span v-if="currentConversation.group_type !== groupTypeEnums.CLIENT_SERVICE" class="fw-bold fs-3"> {{ currentConversationName }} </span>
        <span v-else class="fw-bold fs-3"> {{  'Service Client ' + currentConversationName }} </span>
        <span v-if="!isGroupConversation && currentConversation.group_type !== groupTypeEnums.CLIENT_SERVICE" class="text-primary">
          <span v-if="isOnline" class="text-primary"> En ligne </span>
          <span v-else class="text-danger"> Hors ligne </span>
        </span>
        <span v-if="isGroupConversation && currentConversation.group_type !== groupTypeEnums.CLIENT_SERVICE" class="cursor-pointer text-hover-primary" @click.prevent="toggleShowModal"> <i class="fa fa-users me-1">  </i> {{ conversationUser.length }}</span>
      </div>
      <a @click.prevent="startCall" class="btn btn-outline-primary bg-hover-light btn-icon mx-1">
        <i class="fa fa-video fs-2 text-primary"></i>
      </a>
      <DiscussionActions v-if="iAmAdmin || !isGroupConversation" :discussion-id="currentConversation.id" @callback="closeConversation" />
    </div>
    <div ref="messagesContent" style="height: calc(100% - 80px); max-height: calc(100% - 80px)" class="d-flex flex-column mt-5 scroll-y position-relative">
      <div class="position-absolute end-50 bg-white opacity-5" v-show="false">
        <div class="d-flex justify-content-center align-items-center" >
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">{{ $t("loadingText") }}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="conversationData.other.length" :key="index" v-for="(data, index) in conversationData.other">
        <h4 class="text-center my-5"> {{ $dateFormatter(data.date, locale, true) }} </h4>
        <template :key="index" v-for="(data, index) in data.items">
          <Call
              v-if="data.dataType === discussionDataType.CALL"
              :user="currentUser"
              :participators="currentConversation.participators"
              :call="data"
              :is-group="isGroupConversation"
          />
          <Action
              v-else-if="data.dataType === discussionDataType.ACTION"
              :action="data"
          />
          <Message
              v-else
              :message="data"
              :share="() => toggleShareModal(data)"
              @click.prevent="() => selectedMessage = data.id"
              :is-selected="selectedMessage === data.id"
          />
        </template>

      </template>
      <h4 v-if="conversationData.yesterday.length" class="text-center my-5"> {{ $t('yesterday') }} </h4>
      <template v-if="conversationData.yesterday.length" :key="index" v-for="(data, index) in conversationData.yesterday">
        <Call
            v-if="data.dataType === discussionDataType.CALL"
            :user="currentUser"
            :participators="currentConversation.participators"
            :call="data"
            :is-group="isGroupConversation"
        />
        <Action
            v-else-if="data.dataType === discussionDataType.ACTION"
            :action="data"
        />
        <Message
            v-else
            :message="data"
            :is-selected="selectedMessage === data.id"
            :share="() => toggleShareModal(data)"
            @click.prevent="() => selectMessage(data.id)"

        />
      </template>
      <h4 v-if="conversationData.today.length" class="text-center my-5"> {{ $t('today') }} </h4>
      <template v-if="conversationData.today.length" :key="index" v-for="(data, index) in conversationData.today">
        <Call
            v-if="data.dataType === discussionDataType.CALL"
            :user="currentUser"
            :call="data"
            :is-group="isGroupConversation"
        />
        <Action
            v-else-if="data.dataType === discussionDataType.ACTION"
            :action="data"
        />
        <Message
            v-else
            :message="data"
            :share="() => toggleShareModal(data)"
            :is-selected="selectedMessage === data.id"
            @click.prevent="() => selectMessage(data.id)"
        />
      </template>
    </div>
    <div class="d-flex align-items-center border-top bg-white w-100 position-relative" style="max-height: 200px; height: auto; min-height: 100px">
      <a v-if="!isRecording &&  !audioUrl" class="btn btn-primary btn-icon mx-1" @click.prevent="sendFile">
        <i class="fa fa-paperclip fs-2"></i>
      </a>
      <a v-if="!isRecording &&  !audioUrl" @click.prevent="startRecording" class="btn btn-primary btn-icon mx-1">
        <i class="fa fa-microphone fs-2"></i>
      </a>

      <a @click.prevent="stopRecording" v-if="isRecording && !audioUrl" class="btn btn-danger btn-icon mx-1">
        <i class="fa fa-stop-circle fs-2"></i>
      </a>

      <div class="w-100" v-show="isRecording && !audioUrl">
        <span id="timer" class="fs-2 mx-3">00:00</span>
        <canvas id="visualizer" style="height: calc(1.5em + 1.5rem + 2px); width: 80%"></canvas>
      </div>

      <audio  v-if="audioUrl" :src="audioUrl" controls  style="height: calc(1.5em + 1.5rem + 2px); width: 100%"></audio>

      <a v-if="audioUrl" @click.prevent="audioUrl=null" class="btn btn-danger btn-icon mx-2">
        <i class="las la-trash fs-2"></i>
      </a>


      <div v-if="!audioUrl && !isRecording" class="d-flex align-items-center w-100 bg-white h-100">
        <div v-if="files.length" class="w-80 h-100 positive-relative hover-scroll-y scroll-y">
          <div class="d-flex flex-wrap mt-3" >
            <Card class="mx-2 mb-1" v-for="(file, index) in files" >
              <div class="d-flex justify-content-between align-items-center p-3">
                {{ file.name }}
                <i class="bi bi-x fs-2 ms-3 cursor-pointer" @click.prevent="removeFile(index, file)"></i>
              </div>
            </Card>
          </div>
        </div>
        <div v-if="!files.length" class="w-100">
          <textarea
              v-if="!isRecording && !audioUrl"
              v-model="content"
              :class="{ 'form-control': true, 'is-invalid': errors?.message }"
              :placeholder="$t('chat.writeMessage')"
              class="form-control" rows="1"
              @keypress.enter="sendMessage"
          ></textarea>
        </div>
        <input ref="sendFiles" type="file" multiple hidden @change.prevent="handleUploadFiles" />
      </div>
      <a v-if="audioUrl || !isRecording" @click.prevent="send " class="btn btn-primary btn-icon mx-1">
        <i class="la la-send-o fs-2"></i>
      </a>
    </div>
  </Card>
  <GroupConversationDetail id="show-group-detail-modal" :conversation="currentConversation" />
  <ShareMessageModal id="share-message-modal" :message="toSharedMsg" />
</template>

<script setup>

import Card from "@/components/Card.vue";
import Message from "@/Modules/Chat/components/Message.vue";
import Action from "@/Modules/Chat/components/Action.vue";
import AvatarBadge from "@/components/AvatarBadge.vue";
import Call from "@/Modules/Chat/components/Call.vue";
import GroupConversationDetail from "@/Modules/Chat/components/modals/GroupConversationDetail.vue";
import ShareMessageModal from "@/Modules/Chat/components/modals/ShareMessageModal.vue";
import discussionDataType from "@/Modules/Chat/composables/discussionDataType";

import {computed, defineProps, ref, onMounted, watch, nextTick} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";

import {useLocales} from "@/composables/locales";
import {$dateFormatter, createFormData, groupByDate} from "@/mixins/Helpers";
import {useChatEnums} from "@/Modules/Chat/composables/chatEnums";
import Button from "@/components/Button.vue";
import DiscussionActions from "@/Modules/Chat/components/DiscussionActions.vue";

const { groupTypeEnums } = useChatEnums()
const { locale } = useLocales()
const emits = defineEmits(['closeConversation'])
const props = defineProps({
  query: {
    type: Object,
    default: () => ({
      search: '',
      conversation: ''
    })
  },
  startCall: Function
})

const content = ref('')
const files = ref([])
const errors = ref({})
const messagesContent = ref(null)
const mediaRecorder = ref(null)
const audioChunks = ref([])
const isRecording = ref(false)
const audioBlob = ref(null)
const audioUrl = ref(null)
const startTime = ref(0);
let timerInterval = ref(0);
const sendFiles = ref(null)
const toSharedMsg = ref({})
const selectedMessage = ref('')

const store = useStore()
const route = useRoute()

const currentConversation = computed(() => store.getters['chat/getConversation'](props.query.conversation))
const messages = computed(() => store.getters['chat/getMessages'](props.query.conversation))
const calls = computed(() => store.getters['chat/getCalls'](props.query.conversation))
const actions = computed(() => store.getters['chat/getActions'](props.query.conversation))
const conversationData = computed(() => {
  if (!messages.value || !calls.value || !actions.value) return [];

  const formattedMessages = messages.value.map(item => ({
    ...item,
    dataType: discussionDataType.MESSAGE,
  }));

  const formattedCalls = calls.value.map(item => ({
    ...item,
    dataType: discussionDataType.CALL,
  }));

  const formattedActions = actions.value.map(item => ({
    ...item,
    dataType: discussionDataType.ACTION,
  }));

  const combinedData = [...formattedMessages, ...formattedCalls, ...formattedActions];

  return groupByDate(combinedData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)));

});

const getSelectCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])

const isOnline = computed(() => {
  if (currentConversation.value.is_group) {
    return false
  }

  return store.getters['offices/onlineDiscussion'](getSelectCompanyId.value, currentConversation.value?.peer?.id)
})


const currentUser = computed(() => store.getters['user/currentUser'])
const lastMessage = computed(() => messages.value[messages.value.length - 1])
const saveMessage = computed(() => !audioUrl.value ? sendMessage : uploadAudio)
const currentConversationName = computed(() => {
  if(!currentConversation.value) {
    return ''
  }

  if(currentConversation.value.is_group) {
    return currentConversation.value.name
  }

  return currentConversation.value.peer?.name
})
const isGroupConversation = computed(() => !!currentConversation.value?.is_group)
const conversationUser = computed(() => store.getters['chat/getCurrentConversationUsers'])
const conversationAdmins = computed(() => {
  if(!conversationUser.value.length) return []
  return conversationUser.value.filter(user => user.is_admin)
})
const iAmAdmin = computed(() => conversationAdmins.value.find(p => p.participator_id === currentUser.value.id) || false)


watch(() => lastMessage.value, (value) => {
  if(value) {
    scrollBottom()
  }
})

watch(() => props.query.conversation, () => {
  loadMessages()
  loadCalls()
  loadActions()
  store.dispatch('chat/loadConversationUsers', props.query.conversation)
})

watch(currentConversationName, (value) => {
  if(!value && props.query.conversation) {
    closeConversation()
  }
}, { deep: true })

onMounted(() => {
  loadMessages()
  loadCalls()
  loadActions()
  store.dispatch('chat/loadConversationUsers', props.query.conversation)
})

function loadMessages() {
  store.dispatch('chat/loadMessages', props.query.conversation)
}
function loadCalls() {
  store.dispatch('chat/loadCalls', props.query.conversation)
}

function loadActions() {
  store.dispatch('chat/loadActions', props.query.conversation)
}


async function sendMessage(e){
  if(e.shiftKey === false){
    e.preventDefault()
    errors.value = {}
    try{
      await store.dispatch('chat/sendMessage', {
        content: content.value,
        conversationId: props.query.conversation
      })
      content.value = ''
    }catch(e) {
      errors.value = e.errors
    }
  }
}

function scrollBottom() {
  nextTick(() => {
    messagesContent.value.scrollTop = messagesContent.value.scrollHeight
  })
}

async function startRecording() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorder.value = new MediaRecorder(stream);
    audioChunks.value = [];

    startTime.value = Date.now();

    mediaRecorder.value.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunks.value.push(event.data);
      }
    };

    mediaRecorder.value.onstop = () => {
      audioBlob.value = new Blob(audioChunks.value, { type: 'audio/webm' });
      audioUrl.value = URL.createObjectURL(audioBlob.value);
    };

    mediaRecorder.value.start();
    isRecording.value = true;

    document.getElementById('timer').textContent = '00:00';
    timerInterval.value = setInterval(updateDuration, 1000);
    setupVisualizer(stream);


  } catch (error) {
    console.error("Erreur lors de l'initialisation du micro :", error);
  }
}
function stopRecording() {
  if (mediaRecorder.value && isRecording.value) {
    mediaRecorder.value.stop();
    isRecording.value = false;

    clearInterval(timerInterval.value);

    let tracks = mediaRecorder.value.stream.getTracks();
    tracks.forEach(track => track.stop());


    if (audioContext) {
      audioContext.close();
    }
  }
}

async function uploadAudio() {
  if (!audioBlob.value) return;

  const formData = new FormData();
  formData.append("audio", audioBlob.value, "audio.webm");

  try {
    await store.dispatch('chat/sendAudio', {
      audio: formData,
      conversationId: props.query.conversation
    }).then(() => {
      audioUrl.value = null
      audioBlob.value = null
    })
  } catch (error) {
    console.error("Erreur lors de l'upload :", error);
  }
}

async function sendFileMessage() {
  if (!files.value.length) return;

  const formData = createFormData({files: files.value});
  formData.append("_method","POST");

  try {
    await store.dispatch('chat/sendFiles', {
      files: formData,
      conversationId: props.query.conversation
    }).then(() => {
      files.value = []
    })
  } catch (error) {
    console.error("Erreur lors de l'upload :", error);
  }
}

function updateDuration() {
  const elapsedTime = Math.floor((Date.now() - startTime.value) / 1000);
  const minutes = String(Math.floor(elapsedTime / 60)).padStart(2, '0');
  const seconds = String(elapsedTime % 60).padStart(2, '0');
  document.getElementById('timer').textContent = `${minutes}:${seconds}`;
}

var audioContext, analyser, dataArray, canvas, canvasCtx;

function setupVisualizer(stream) {
  audioContext = new (window.AudioContext || window.webkitAudioContext)();
  analyser = audioContext.createAnalyser();

  const source = audioContext.createMediaStreamSource(stream);
  source.connect(analyser);
  analyser.fftSize = 256;

  dataArray = new Uint8Array(analyser.frequencyBinCount);

  canvas = document.getElementById("visualizer");
  canvasCtx = canvas.getContext("2d");

  drawOscillations();
}


function drawOscillations() {
  if (!isRecording.value) return;

  requestAnimationFrame(drawOscillations);

  analyser.getByteFrequencyData(dataArray);

  canvasCtx.clearRect(0, 0, canvas.width, canvas.height);

  const barWidth = (canvas.width / dataArray.length) * 2.5;
  let barHeight;
  let x = 0;

  for (let i = 0; i < dataArray.length; i++) {
    barHeight = dataArray[i] / 2;
    canvasCtx.fillStyle = `rgb(0, 122, ${barHeight + 100})`;
    canvasCtx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);
    x += barWidth + 1;
  }
}

function sendFile () {
  sendFiles.value.click()
}

function handleUploadFiles (e) {
  const lastIndex = files.value?.length
  e.target.files.forEach((el, index) => { files.value[lastIndex + index] = el })
}

function removeFile (index, file) {
  files.value.splice(index, 1)
}

function getFileUrl (file) {
  return URL.createObjectURL(file)
}

function send (e) {
  if(files.value.length)
    return sendFileMessage();

  if(audioUrl.value) {
    return uploadAudio()
  }

  return sendMessage(e)
}

function toggleShowModal() {
  if(isGroupConversation.value) {
    $('#show-group-detail-modal').modal('toggle')
  }
}

function toggleShareModal (message) {
  toSharedMsg.value = null
  toSharedMsg.value = {...message}
  $('#share-message-modal').modal('toggle')
}

function selectMessage (id) {
  if(!selectedMessage.value || selectedMessage.value !== id) {
    selectedMessage.value = id ;
  } else {
    selectedMessage.value = null;
  }
}

function closeConversation() {
  emits('closeConversation')
}

</script>

<style scoped>


</style>